module.exports = __webpack_public_path__ + "img/1296074241.294cb62d.jpg";